import { j as c } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const i = e((l, s) => /* @__PURE__ */ c.jsx(
  r,
  {
    ref: s,
    ...l,
    image: (a) => /* @__PURE__ */ c.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...a,
        children: [
          /* @__PURE__ */ c.jsxs("g", { clipPath: "url(#clip0_2974_4137)", children: [
            /* @__PURE__ */ c.jsxs(
              "mask",
              {
                id: "mask0_2974_4137",
                width: 32,
                height: 32,
                x: 8,
                y: 8,
                maskUnits: "userSpaceOnUse",
                style: {
                  maskType: "alpha"
                },
                children: [
                  /* @__PURE__ */ c.jsx(
                    "path",
                    {
                      fill: "currentColor",
                      d: "M24 8C15.18 8 8 15.18 8 24s7.18 16 16 16 16-7.18 16-16S32.82 8 24 8m0 30.5C16 38.5 9.5 32 9.5 24S16 9.5 24 9.5 38.5 16 38.5 24 32 38.5 24 38.5"
                    }
                  ),
                  /* @__PURE__ */ c.jsx(
                    "path",
                    {
                      fill: "currentColor",
                      d: "M24 14.33c.41 0 .75-.34.75-.75v-1.91c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.91c0 .41.34.75.75.75M36.33 23.25h-1.91c-.41 0-.75.34-.75.75s.34.75.75.75h1.91a.749.749 0 1 0 0-1.5M33.04 19.53c.13 0 .26-.03.37-.1l1.64-.95c.36-.21.48-.67.27-1.02a.75.75 0 0 0-1.02-.27l-1.64.95a.746.746 0 0 0 .38 1.39M28.83 15.63c.12.07.25.1.37.1.26 0 .51-.13.65-.38l.96-1.67a.746.746 0 0 0-1.29-.75l-.96 1.67c-.21.37-.09.83.27 1.03M18.14 15.35c.14.24.39.38.65.38.13 0 .26-.03.37-.1.36-.21.48-.67.27-1.02l-.95-1.65a.74.74 0 0 0-1.02-.27c-.36.19-.48.64-.28 1zM12.94 18.48l1.65.95c.12.07.25.1.37.1.26 0 .51-.13.65-.38.21-.36.08-.82-.27-1.02l-1.65-.95a.754.754 0 0 0-1.02.28c-.21.36-.09.82.27 1.02M29.86 32.65a.74.74 0 0 0-1.02-.27c-.36.21-.48.67-.27 1.02l.96 1.66c.14.24.39.38.65.38.13 0 .26-.03.37-.1.36-.21.48-.67.27-1.02zM35.06 29.52l-1.65-.95a.746.746 0 0 0-.75 1.29l1.65.95c.12.07.25.1.37.1.26 0 .51-.13.65-.38.21-.35.09-.81-.27-1.01M14.34 24c0-.41-.34-.75-.75-.75h-1.92c-.41 0-.75.34-.75.75s.34.75.75.75h1.92c.41 0 .75-.34.75-.75M14.61 28.55l-1.67.96c-.36.21-.48.67-.27 1.02.14.24.39.38.65.38.13 0 .26-.03.37-.1l1.67-.96c.36-.21.48-.67.27-1.02a.75.75 0 0 0-1.02-.28M19.17 32.37a.746.746 0 0 0-1.02.27l-.96 1.66a.746.746 0 0 0 .64 1.12c.26 0 .51-.13.65-.38l.96-1.66c.21-.34.08-.8-.27-1.01M24 33.67c-.41 0-.75.34-.75.75v1.91c0 .41.34.75.75.75s.75-.34.75-.75v-1.91c0-.41-.34-.75-.75-.75"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ c.jsx("g", { mask: "url(#mask0_2974_4137)", children: /* @__PURE__ */ c.jsx("path", { fill: "currentColor", d: "M1.902 1.685h43.962v43.962H1.902z" }) })
          ] }),
          /* @__PURE__ */ c.jsx("defs", { children: /* @__PURE__ */ c.jsx("clipPath", { id: "clip0_2974_4137", children: /* @__PURE__ */ c.jsx("path", { fill: "#fff", d: "M0 0h48v48H0z" }) }) })
        ]
      }
    )
  }
));
i.displayName = "AgencyNeverClockIcon";
export {
  i as AgencyNeverClockIcon,
  i as default
};
//# sourceMappingURL=index.js.map
